import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "FaqRecent",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getFaqRecents, getFaqRecentsError, getFaqRecentsSuccess } =
  slice.actions;

reducerRegistry.register("faqRecent", reducer);
